<template>
  <article class="card">
    <a
      :href="item.link"
    >
      <div class="card__thumbnail">
        <img
          :src="require(`@/assets/images/${item.thumbnail}`)"
          alt=""
        >
      </div>
      <h3 class="card__title">
        {{ item.title }}
      </h3>
    </a>
  </article>
</template>

<script>
export default {
  name: 'ResultRecommendItem',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
  }
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/foundation/config/colors";
@use "@/assets/scss/foundation/config/mediaquery";
@use "@/assets/scss/foundation/mixin";

.card {
  text-align: left;
  a {
    display: block;
  }
}

.card__thumbnail {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  aspect-ratio: 1.3 / 1;
  border: 2px solid colors.$color-button;
  border-radius: 10px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.card__title {
  margin-top: .5em;
  @include mediaquery.minMediaMajor {
    line-height: 1.5;
    font-size: 1.8rem;
  }
}
</style>